// ==============================|| CHUNK ERROR DETECTION ||============================== //

/**
 * Checks whether the given error is a chunk/dynamic-import loading failure.
 * Used by both the Loadable error boundary and the router-level ErrorBoundary.
 */
export function isChunkLoadError(error) {
  if (!error) return false;
  const message = error?.message || '';
  return (
    error.name === 'ChunkLoadError' ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes('error loading dynamically imported module')
  );
}
